export enum ExternalErrorCode {
    INCORRECT_SECRET = 'INCORRECT_SECRET',
    INCORRECT_TOKEN = 'INCORRECT_TOKEN',
    INVALID_CERTIFICATE = 'INVALID_CERTIFICATE',
    IP_ADDRESS_NOT_WHITELISTED = 'IP_ADDRESS_NOT_WHITELISTED',
    MISSING_SECRET = 'MISSING_SECRET',
}
